import Carousel from "bootstrap/js/dist/carousel";

export default function CarouselSlide(carouselId) {
  const carouselEl = document.querySelector(carouselId);

  if (carouselEl) {
    const carousel = new Carousel(carouselEl, {
      interval: 3000
    });

    console.log("carousel deprecated");
    carouselOnResize();

    window.addEventListener("resize", () => {
      carousel.cycle();
    });
  }
}
